var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBachelors(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.558716,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.0587C14 18.2303 14.6716 17.5587 15.5 17.5587C16.3284 17.5587 17 18.2303 17 19.0587V26.0587C17 26.8871 16.3284 27.5587 15.5 27.5587C14.6716 27.5587 14 26.8871 14 26.0587V19.0587Z",
    fill: "#00AAEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 17.0587C18.5 16.2303 19.1716 15.5587 20 15.5587C20.8284 15.5587 21.5 16.2303 21.5 17.0587V26.0587C21.5 26.8871 20.8284 27.5587 20 27.5587C19.1716 27.5587 18.5 26.8871 18.5 26.0587V17.0587Z",
    fill: "#00AAEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15.0587C23 14.2303 23.6716 13.5587 24.5 13.5587C25.3284 13.5587 26 14.2303 26 15.0587V26.0587C26 26.8871 25.3284 27.5587 24.5 27.5587C23.6716 27.5587 23 26.8871 23 26.0587V15.0587Z",
    fill: "#00AAEE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBachelors);
export default __webpack_public_path__ + "static/media/bachelors.20fc9a7cb5c64f4110d561ccb3b6a394.svg";
export { ForwardRef as ReactComponent };